<template>
    <generic-modal :show="show" @closing="handleClose">
        <div ref="policyContent" class="prose lg:prose-lg">
            <div v-if="policy">
                <h3>{{ policy.title }}</h3>
                <div v-html="policy.content"></div>
            </div>
            <div v-else-if="error">
                <p class="text-red-600">{{ error }}</p>
            </div>
        </div>
    </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";

export default {
    name: 'PolicyModal',
    components: {GenericModal},

    data() {
        return {
            show: false,
            policy: null,
            activePolicy: '',
            isLoading: false,
            error: null,
        };
    },

    created() {
        this.onShowPolicy = (activePolicy) => {
            this.getPolicy(activePolicy);
        };

        this.onClosePolicy = () => {
            this.handleClose();
        };
    },

    mounted() {
        this.$event.$on('policy-modal:show', this.onShowPolicy);
        this.$event.$on('policy-modal:close', this.onClosePolicy);
    },

    beforeUnmount() {
        this.$event.$off('policy-modal:show', this.onShowPolicy);
        this.$event.$off('policy-modal:close', this.onClosePolicy);
    },

    methods: {
        handleClose() {
            this.show = false;
        },

        resetScroll() {
            this.$nextTick(() => {
                const el = this.$refs.policyContent;

                if (el) {
                    el.scrollTop = 0;
                    el.parentElement?.scrollTo?.({ top: 0, left: 0 });
                }
            });
        },

        async getPolicy(activePolicy) {
            if (!activePolicy) {
                return;
            }

            if (this.activePolicy === activePolicy && this.policy) {
                this.show = true;
                this.resetScroll();
                return;
            }

            this.isLoading = true;
            this.error = null;
            this.show = true;
            this.resetScroll();

            try {
                const response = await this.$http.get(route('api.policy.show', activePolicy));
                this.policy = response.data;
                this.activePolicy = activePolicy;
            } catch (error) {
                this.activePolicy = '';
                this.policy = null;
                this.error = 'Unable to load this policy right now. Please try again later.';
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
